import { useQuery } from '@apollo/client';

import DailyQuestionQuery from 'graphql/gamification/queries/dailyQuestion.graphql';

import { GetDailyQuestionQuery } from 'graphql/types';

export const useDailyQuestion = (competitionSlug: string) =>
  useQuery<GetDailyQuestionQuery>(DailyQuestionQuery, {
    variables: { competitionSlug },
    // TODO: убрать, когда появится модуль работы с кешом
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });
